// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_2787e5dfdf--tooltip--Rln6T","arrow":"_2787e5dfdf--arrow--GMnRq"};